module.exports = __webpack_public_path__ + "img/8.198bb2c4.jpg";